<template>
    <div class="card">
        <div class="container-fluid">
             <div class="row">
                <div style="width:100%;height:5px;"></div>
                <div style="width:24%;margin-bottom:5px">
                    <VueCtkDateTimePicker formatted='ll' v-validate="'required'" format="YYYY-MM-DD"  :range="true" name="date" :label="'সময়সীমা নির্বাচন করুন'" v-model="date" />
                    <p v-show="errors.has('date')" style="color:red">* {{ errors.first('date') }}</p>
                </div>
                <div style="width:0.5%;"></div>
                <div style="width:20%;margin-bottom:5px">
                   <input v-model="mobile_number" placeholder="মোবাইল নম্বর" style="height:41px;min-height:41px;" class="form-control" type="text">
                </div>
                <div style="width:0.5%;"></div>
                <div style="width:20%;margin-bottom:5px">
                   <input v-model="account_no" placeholder="একাউন্ট নম্বর" style="height:41px;min-height:41px;" class="form-control" type="text">
                </div>
                <div style="width:0.5%;"></div>
                <div style="width:20%;margin-bottom:5px">
                    <select v-model="type" style="height:41px;min-height:41px;" class="form-control">
                        <option value="">আবেদনের ধরন</option>
                        <option value="new-water-connection">নতুন পানি সংযোগ</option>
                        <option value="update-water-connection">হালনাগাদ পানি সংযোগ</option>
                        <option value="remove-water-connection">বাতিল পানি সংযোগ</option>
                    </select>
                </div>
                <div style="width:0.5%;"></div>
                <div style="width:20%;margin-bottom:5px">
                    <select v-model="status" style="height:41px;min-height:41px;" class="form-control">
                        <option value="">স্ট্যাটাস</option>
                        <option value="0">অচল/পেন্ডিং</option>
                        <option value="1">সচল</option>
                        <option value="2">বাতিলকৃত</option>
                    </select>
                </div>
                <div style="width:0.5%;"></div>
                <div style="width:24%;padding-bottom:5px">
                   <select v-model="ward"  name="word_no"  style="height:41px;min-height:41px;"  class="form-control" >
                        <option  value="">ওয়ার্ড নির্বাচন করুন</option>
                        <option v-for="(ward,key) in wards" :key="key" :value="ward.id" >{{ ward.ward_name_bng}}</option>
                    </select>
                </div>
                <div style="width:0.5%;"></div>
                <div style="width:7%;margin-bottom:5px; margin-right:10px;"><button @click.prevent="getResults()" style="height:41px;min-height:41px;" class="btn btn-outline-success my-2 my-sm-0" >Search</button></div>
                <div style="width:7;margin-bottom:5px"><button @click.prevent="download()" style="height:41px;min-height:41px;" class="btn btn-outline-success my-2 my-sm-0" >Export</button></div>
                <div style="width:100%;height:5px;"></div>
            </div>
            <table id="my-table" class="table table-sm">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">একাউন্ট নম্বর </th>
                        <th scope="col">গ্রাহকের নাম </th>
                        <th scope="col">মোবাইল নম্বর</th>
                        <th scope="col">ওয়ার্ড নং</th>
                        <th scope="col">আবেদনের ধরন</th>

                        <th scope="col">ডায়া এবং গ্রাহকের ধরন</th>
                        <th scope="col">মাসিক বিল</th>
                        <th scope="col">স্ট্যাটাস</th>
                        <th scope="col">তৈরি সময়</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(datum,key) in data.data" :key="key">
                        <td v-if="data.from">{{data.from+key}}</td>
                        <td><span v-if="datum.account_no"></span>{{datum.account_no}} <span v-if="datum.parent_account">{{datum.parent_account}}</span></td>
                        <td><span>{{datum.user_name}}</span></td>
                        <td>{{datum.mobile_number}}</td>
                        <td>{{datum.ward_no}}</td>
                        <td><span v-if="datum.type == 'new-water-connection'">নতুন সংযোগ</span><span v-if="datum.type == 'update-water-connection'">হালনাগাদ সংযোগ</span><span v-if="datum.type == 'cancel-water-connection'">বাতিল সংযোগ</span></td>

                        <td>{{datum.service_name}} {{datum.diameter}} ইঞ্চি</td>
                        <td>{{datum.monthly_bill}}</td>
                        <td>{{datum.status == 0?"অচল/পেন্ডিং":''}}{{datum.status == 1?"সচল":''}}{{datum.status == 2?"বাতিল":''}}</td>
                        <td>{{datum.created}}</td>
                    </tr>
                </tbody>
            </table>
            <nav  aria-label="Page navigation example">
                <pagination :limit="5" :data="data" @pagination-change-page="loadContents"></pagination>
            </nav>
        </div>
    </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import axios from 'axios';
import { mapGetters } from "vuex"
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
import pagination from 'laravel-vue-pagination'

export default {
    data(){
        return {
            date:'',
            name:'',
            data:{},
            mobile_number:'',
            account_no:'',
            status:'',
            type:'',
            ward:''
        }
    },
    methods:{
        async loadContents(page){
            var start = ''
            var end = ''
            if(this.date){
                start = this.date.start
                end = this.date.end
            }

            var data = {page,ward:this.ward,mobile_number:this.mobile_number,account_no:this.account_no,start,end,status:this.status,type:this.type};

            axios.post('/api/water-application-report?page='+page,data).then(response=>{
                this.data = response.data;
            })
        },
        async getResults(page = 1){
            this.$validator.validateAll().then( result =>{
                if(result){
                    this.loadContents(page)
                }
            })
        },
        download(){
            this.$validator.validateAll().then( result =>{
                if(result){
                    var start = ''
                    var end = ''
                    var download = 'download'
                    if(this.date){
                        start = this.date.start
                        end = this.date.end
                    }
                    window.open(`${axios.defaults.baseURL}/api/water-application-report?ward=${this.ward}&download=${download}&mobile_number=${this.mobile_number}&account_no=${this.account_no}&start=${start}&end=${end}&status=${this.status}&type=${this.type}`)
                }
            })
        },
        wardLists(){
            var invoice_type = ''
            this.$store.dispatch('WARD_LIST',{invoice_type})
        },
    },
    mounted(){
        this.loadContents(1);
        this.wardLists()
    },
    computed:{
        ...mapGetters(['wards'])
    },
    components: {
        VueCtkDateTimePicker,
        pagination
    }
}
</script>
<style scoped>
.field-input{
    height: 30px !important;
}
 .actn{
     margin-left: 10px;
     cursor: pointer;
 }
 .contct{
     padding-bottom: 10px;
     padding-top: 10px
 }
 .contct-b{
     margin-bottom: 10px;
     margin-top: 10px
 }
 .load{
     margin-left: 50%;
 }
</style>
